var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.352 6.608A4.313 4.313 0 0 1 15.392 3h-3.095l-.005 12.402a2.602 2.602 0 0 1-2.596 2.503 2.603 2.603 0 0 1-2.601-2.601 2.604 2.604 0 0 1 2.6-2.601c.269 0 .525.044.768.12v-3.16a5.676 5.676 0 0 0-.767-.055A5.702 5.702 0 0 0 4 15.304c0 1.927.963 3.632 2.432 4.664A5.663 5.663 0 0 0 9.696 21a5.702 5.702 0 0 0 5.696-5.696V9.015a7.36 7.36 0 0 0 4.305 1.385V7.305c-.864 0-1.67-.257-2.345-.697Z",
  fill: "currentColor"
})));
export default SvgTiktok;